import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import type { IChartType } from '@model/chartType';

import { apiClient } from '@services/apiClient';

interface IResponse {
  data: Array<IChartType>;
}

export const chartsTypesListKey = (pointId?: number) => ['chartsTypesList', pointId];

export const chartsTypesListFn = ({ queryKey }: QueryFunctionContext<(string | number)[]>) =>
  apiClient.get(`${APP_API_URL_V2}fsd/chart-types/installation-point/${queryKey[1]}`);

const chartsTypesListSelect = ({ data }: AxiosResponse<IResponse>) => data.data;

export const useChartsTypesListQuery = ({ pointId }: { pointId?: number }) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: chartsTypesListKey(pointId),
    queryFn: chartsTypesListFn,
    enabled: !!pointId,
    select: chartsTypesListSelect,
    placeholderData: {
      data: {
        data: [],
      },
    },
  });
};
